import React, { useState, useEffect, useRef } from 'react'
import './index.scss'
import { getBrands } from '../../services/searchService'
import checkIcon from '../../assets/images/Checkmark.png'
import BtnContent from '../../components/BtnContent'
import { IDefaultSortProps } from '../DefaultSort/index'
import { CategoriesContext } from '../../lib/context'
const BrandSort = (props: IDefaultSortProps) => {
    const { setSearchQuery, q, searchProducts } = props
    const [brands, setBrands] = useState<any[]>([])
    const [searchValue, setsearchValue] = useState('A')
    const contentRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        getAllBrands()
    }, [])
    const getAllBrands = (n = 'A') => {
        setsearchValue(n)
        let node = contentRef.current
        if (node) {
            node.scrollTop = 0
        }
        getBrands(n)
            .then(res => {
                setBrands(res.data?.brands)
            })
            .catch(err => {
                console.log(err)
            })
    }
    let isSelect = (id: string) => {
        if (!q.selectBrands) return false
        return q?.selectBrands?.indexOf(id) !== -1
    }
    const chooseBrand = id => {
        let eIndex = q?.selectBrands?.indexOf(id)
        let eBrands = q?.selectBrands ? [...q?.selectBrands] : []
        if (eIndex !== -1) {
            eBrands.splice(eIndex, 1)
        } else {
            eBrands.push(id)
        }
        setSearchQuery('selectBrands', eBrands)
    }
    const arr = new Array(26).fill('').map((item, i) => {
        return String.fromCharCode(65 + i)
    })
    const resetQuery = () => {
        setSearchQuery('selectBrands', [])
    }
    return (
        <>
            {brands.length > 0 && (
                <div className="brandAllContent" ref={contentRef}>
                    <div className="letterList">
                        {arr.map((item, index) => {
                            return (
                                <div
                                    key={`brand${index}`}
                                    onClick={() => getAllBrands(item)}
                                    className={`charCode ${
                                        searchValue === item ? 'active' : ''
                                    }`}
                                >
                                    {item}
                                </div>
                            )
                        })}
                    </div>
                    <div className="brandTitle">{searchValue}</div>
                    {brands.map((item, index) => {
                        return (
                            <div
                                className="brandItem"
                                key={`brandItem${index}`}
                            >
                                <span
                                    className={`brandName ${
                                        isSelect(item.id) ? 'active' : ''
                                    }`}
                                    onClick={() => chooseBrand(item.id)}
                                >
                                    {item.name}
                                </span>
                                {isSelect(item.id) && (
                                    <img
                                        className="checkIcon"
                                        src={checkIcon}
                                        alt=""
                                    ></img>
                                )}
                            </div>
                        )
                    })}
                </div>
            )}
            <BtnContent
                resetQuery={resetQuery}
                sureSearch={searchProducts}
            ></BtnContent>
        </>
    )
}

export default BrandSort
